import script from "./Content.vue?vue&type=script&setup=true&lang=ts"
export * from "./Content.vue?vue&type=script&setup=true&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=64fe541a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fe541a"]])

export default __exports__